import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, FormControlLabel, Switch, withStyles } from '@material-ui/core';
import InputField from '../../../lib/ui/inputs/Input';
import { RxCross2 } from "react-icons/rx";

const AdditionalParameters = ({ handleClose, open }) => {
    const CustomSwitch = withStyles({
        switchBase: { // Thumb color when unchecked
          '&$checked': {
            color: '#24a4c4', // Thumb color when checked
          },
          '&$checked + $track': {
            backgroundColor: '#24a4c4', // Track color when checked
          },
        },
        checked: {},
        track: {},
      })(Switch);
    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth='sm'>
            <DialogTitle id="form-dialog-title">
                <div className='flexRow alignCenter'>
                    <div className=' flexMinWidthRow'>
                        Add  Parameter
                    </div>
                    <div className='flexAutoRow pointer' onClick={handleClose}>
                        <RxCross2 fontSize={20} />
                    </div>
                </div></DialogTitle>
            <DialogContent>
                <div className='flexCol'>
                    <small className="pdngVSX">Field Name</small>
                    <div className="inputRowFeild" >
                        <InputField
                            placeholder="Enter Field Name"
                            type="text"
                            id='code'
                            name='code'
                            maxLength={6}
                        />
                    </div>
                    <span className='pdngVSX font18'>
                    Select Input Type
                    </span>
                    <FormControlLabel required control={<CustomSwitch />} label="Required"/>
                </div>

            </DialogContent>
            <DialogActions>
            <div className="flexInline pdngHSM capitalTxt">
                            <Button variant='outlined' color="primary" onClick={handleClose}>
                                cancel
                            </Button>
                        </div>
                        <Button variant="contained" color="primary" className="whiteTxt capitalTxt">
                            Save
                        </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdditionalParameters;